<template>
  <div class="left-chart-3 mt-3 p-2 border card-background">
    <!-- <h3 class="mb-3 font-bold">居民主要疾病-柱状图</h3> -->
    <!-- <dv-decoration-11 style="width: 100%; height: 40px; margin-bottom: 10px"
      >&nbsp; &nbsp;居民主要疾病&nbsp;&nbsp;</dv-decoration-11
    > -->
    <!-- <dv-border-box-13 :color="[$color.borderColor, $color.borderColor]"> -->
    <div class="h-full">
      <div style="width: 100%; padding-top: 0px">
        <ComponentSubtitle
          ><span class="sub-title">居民满意度指数</span>
        </ComponentSubtitle>
      </div>
      <div class="mt-0 border" style="height: 100%">
        <div id="consumption-pie" style="width: 100%; height: 140px"></div>
      </div>
    </div>
    <!-- </dv-border-box-13> -->
  </div>
</template>

<script>
import * as echarts from "echarts";
import { mapGetters } from "vuex";
import DialogUserTable from "./DialogUserTable.vue";
import DialogArchivesCard from "./DialogArchivesCard.vue";
import axios from "axios";
export default {
  name: "LeftChart3",
  data() {
    let circularGraph = {
      head: true,
      tuglie: ["非常满意", "满意", "一般", "不满意"],
      data: [
        {
          name: "非常满意",
          value: 99,
        },
        {
          name: "满意",
          value: 1,
        },
        {
          name: "一般",
          value: 0,
        },
        {
          name: "不满意",
          value: 0,
        },
      ],
      sum: {
        name: [],
        number: 0,
      },
      // color: ["#3aa0ff", "#36cbcb", "#4dcb73", "#975fe4"],
      color: ["#DFBDBB", "#409EFF", "#4dcb73", "#975fe4"],
    };
    let sum = 0;
    circularGraph.data.map((item) => {
      sum += item.value;
    });
    circularGraph.sum.number = sum;
    const getname = circularGraph.data.map((v) => v.name);
    let option = {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)",
      },
      legend: {
        type: "scroll",
        orient: "vertical",
        height: "88%",
        right: "12%",
        top: "center",
        icon: "circle",
        itemWidth: 10,
        itemHeight: 10,
        itemGap: 10,
        data: getname,
        axisPointer: {
          type: "none",
        },
      },
      graphic: {
        type: "text",
        left: "15%",
        top: "center",
        style: {
          text:
            String(circularGraph.sum.number).replace(
              /(\d)(?=(?:\d{6})+$)/g,
              "$1."
            ) + "%",
          // textAlign: "center",
          fill: "#DFBDBB",
          width: 30,
          height: 30,
          fontSize: 18,
          fontWeight: 600,
        },
      },
      series: [
        {
          type: "pie",
          radius: ["50%", "70%"],
          center: ["20%", "50%"],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
              textColor: "#000",
            },
          },
          label: {
            normal: {
              show: false,
            },
          },

          labelLine: {
            normal: {
              show: false,
            },
          },
          data: circularGraph.data, //数据
        },
      ],
      color: circularGraph.color, //颜
    };
    return {
      tableData: [],
      option: option,
      visible: false,
      list: [],
      filterList: [],
      visibleArchives: false,
      checkUsers: {},
      title: "",
    };
  },
  components: {
    DialogUserTable,
    DialogArchivesCard,
  },
  computed: {
    ...mapGetters(["globalData", "mapKey", "communityKey", "plotKey"]),
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(() => {
          // this.list = this.globalData["users"] || [];

          this.initChart();
          this.formatterData();
        });
      },
    },
  },
  methods: {
    formatterData() {
      let data = [];
      let sum = 0;
      let orderCategoryCount = this.globalData.orderCategoryCount || {};
      for (let key in orderCategoryCount) {
        sum += orderCategoryCount[key];
        data.push({
          name: key,
          value: orderCategoryCount[key],
        });
      }
      data.forEach((v) => {
        v.scale = Number((v.value / sum) * 100).toFixed(2);
      });
      this.tableData = data;
    },
    onCheckoutItemOfUser(row) {
      this.checkUsers = row;
      // this.getArchivesDetail();
      this.visible = false;
      this.visibleArchives = true;
      return;
    },
    getCategoryUsers(category) {
      this.$axios
        .get("/statisticsService/mechanism/order/categoryUsers", {
          params: {
            category,
            subDistrict: this.mapKey,
            community: this.communityKey,
            village: this.plotKey,
          },
        })
        .then((resp) => {
          this.list = resp.data;
          this.visible = true;
        });
    },

    initChart() {
      var myChart = echarts.init(document.getElementById("consumption-pie"));
      myChart.setOption(this.option);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
table {
  table-layout: fixed;
  width: 100%;
}
tr {
  width: 100%;
  border: 1px solid black;
}
td {
  border: 1px solid @border-color;
  border-collapse: collapse; /* 移除单元格之间的间隔 */
  // width: 35%;
  text-align: center;
  padding: 6px 8px;
}
.left-chart-3 {
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // background: #fff;
  overflow: hidden;
  height: 200px;
  .lc3-header {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc3-details {
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: @primary-color;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc3-chart {
    flex: 1;
  }
}
</style>
